import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apis from "../services";
import { FaSearch } from "react-icons/fa";

const ActiveCoin = ({ showHeader = true }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [tokenData, setTokenData] = useState([]);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedRound, setSelectedRound] = useState(""); // Default selected round
  const [rounds, setRounds] = useState([]);
  const [roundsFetched, setRoundsFetched] = useState(false);

  const navigate = useNavigate();
  const pageSize = 50;

  // Handle Round Change (Dropdown)
  const handleRoundChange = async (e) => {
    const selectedRound = e.target.value;
    setSelectedRound(selectedRound); // Set selected round
    if (selectedRound === "all") {
      fetchTokenData(1, "", true, ""); // Pass empty string or null for 'All' rounds
    } else {
      fetchTokenData(1, "", true, selectedRound); // Fetch data for the selected round
    }
  };

  // Fetch available rounds when the dropdown is focused
  const handleDropdownFocus = async () => {
    if (!roundsFetched) {
      try {
        const response = await apis.activeround();
        if (response.success) {
          setRounds(response.rounds); // Set the fetched rounds
          setRoundsFetched(true);
        }
      } catch (err) {
        console.error("Error fetching upcoming rounds data:", err.message);
      }
    }
  };

  // Fetch Token Data
  const fetchTokenData = async (page, searchedTokenName, isSearched, selectedRound) => {
    setLoading(true);
    try {
      const response = await apis.activeIco({
        page,
        page_size: pageSize,
        tokenName: searchedTokenName,
        isSearched: isSearched,
        round: selectedRound, // Send the selected round (or empty string for 'All')
      });
      const { tokenDetails } = response;

      if (searchedTokenName || isSearched) {
        setTokenData([]); // Clear previous token data if search is applied
      }

      if (tokenDetails.length > 0) {
        const formattedData = tokenDetails.map((token) => ({
          id: token._id,
          name: token.tokenName,
          round: token.Round,
          totalRaised: token.totalRaised,
          preValuation: token.preValuation,
          category: token.category,
          date: token.Date,
          coinImage: token.image,
        }));
        setTokenData((prevData) => [...prevData, ...formattedData]); // Add the new tokens to the existing data
      } else {
        setTokenData(tokenDetails); // No data found for the given search
      }

      if (tokenDetails.length < pageSize) {
        setHasMoreData(false); // Disable 'Show More' button if no more data
      }
    } catch (err) {
      console.error("Error fetching token data:", err.message);
      setTokenData([]); // Clear data if there's an error
      setHasMoreData(false); // Disable 'Show More' button
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // Search Token
  const handleSearchTokens = (e) => {
    const searchedText = e.target.value;
    fetchTokenData(1, searchedText, true, ""); // Pass empty string when searching
  };

  // Effect to fetch token data when page or round changes
  useEffect(() => {
    fetchTokenData(currentPage, "", false, selectedRound);
  }, [currentPage, selectedRound]); // Fetch data when page or round changes

  const handleShowMore = () => {
    if (hasMoreData) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handleCellClick = async (row) => {
    try {
      const data = await apis.getactiveId(row.id);
      navigate(`/PS-detail`, { state: { id: row.id, apiData: data } });
    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  };

  return (
    <div className="newpool-back">
      <div className="mergeSearchbar">
        <div className="search-bar">
          <form>
            <div className="search-input-wrapper">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search by token name"
                onChange={handleSearchTokens}
                className="search-input"
              />
            </div>
          </form>
        </div>

        <div className="upcoming-start-dropdown-container">
          <label htmlFor="round-select" className="upcoming-start-dropdown-label">
            {/* Round: */}
          </label>
          <select
            id="round-select"
            className="upcoming-start-dropdown"
            onChange={handleRoundChange}
            onFocus={handleDropdownFocus}
            value={selectedRound}
          >
            <option value="" disabled>
              Select a round
            </option>
            <option className="asdasdasdasdasdasdasdasd" value="all">All</option> {/* Add "All" option */}
            {rounds.map((round, index) => (
              <option key={index} value={round}>
                {round}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="table-container">
        <table className="table-table-container">
          <thead className="active-header">
            <tr>
              <th>Project Name</th>
              <th>Round</th>
              <th>Total Raised</th>
              <th>Pre-Valuation</th>
              <th>Categories</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {tokenData.map((row, index) => (
              <tr key={index}>
                <td className="coin-name-cell" style={{ cursor: "pointer" }}>
                  <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default anchor behavior
                      handleCellClick(row); // Trigger the onClick event to navigate
                    }}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {/* <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={row.coinImage}
                        alt={row.name}
                        style={{ width: "20px", marginRight: "5px" }}
                      />
                      <span>{row.name}</span>
                    </div> */}
                    <div style={{ display: "flex", alignItems: "center" }}>
  <img
    src={row.coinImage}
    alt={row.name}
    style={{ width: "20px", marginRight: "5px" }}
    onError={(e) => { e.target.src = "/deafult.png"; }}
  />
  <span>{row.name}</span>
</div>

                  </a>
                </td>
                <td>{row.round}</td>
                <td>{row.totalRaised}</td>
                <td>{row.preValuation}</td>
                <td>{row.category}</td>
                <td>{row.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {hasMoreData && (
        <div className="show-more-container">
          <button onClick={handleShowMore} disabled={loading}>
            {loading ? "Loading..." : "Show More"}
          </button>
        </div>
      )}
    </div>
  );
};

export default ActiveCoin;
